import AhPlusPricingPlans from "modules/storyblok/components/AhPlusPricingPlans";

const AhPlusPricingPlansAdapter = () => <AhPlusPricingPlans />;

export default AhPlusPricingPlansAdapter;
